{
    "ACCESS_CODE_NOT_PROVIDED": "Access code not provided",
    "ACCESS_DENIED": "Access denied",
    "ADD_SUB_PARTICIPANT": "Add Sub-participant",
    "ADD_SUB_PARTICIPANTS": "Add invitee",
    "ADD_TO_CALENDAR": "Add to calendar",
    "ADD_TO_EVENT": "Add to event",
    "ADD_TO_REGISTRATION": "Add to registration",
    "ADD_TO_WHISHLIST": "Add to whishlist",
    "AN_EMAIL_WITH_VERIFICATION_HAS_BEEN_SENT_TO_YOU_PLEASE_CHECK_YOUR_INBOX": "An email with verification has been sent to you. Please check your inbox.",
    "APPLY": "Apply",
    "APPROVE": "Approve",
    "BACK": "Back",
    "CANCEL": "Cancel",
    "CANCELBACK": "No, Go Back",
    "CANCELLATION_COST": "Cancellation cost",
    "CANCELLATION_POLICY": "Based on the cancellation policy",
    "CANCELLED": "Cancelled",
    "CANCELLED_SUB_PARTICIPANTS": "Cancelled Sub-participant(s)",
    "CANCELOK": "Yes, Cancel",
    "CANNOT_CREATE_THE_PARTICIPANT": "Cannot create the participant",
    "CANNOT_FIND_FIELD_WITH_ID": "Cannot find field with id",
    "CANNOT_GENERATE_NEW_TOKENS": "Cannot generate new tokens",
    "CANNOT_LOAD_PAGE": "Cannot load page",
    "CANNOT_UPDATE_THE_PARTICIPANT": "Cannot update the participant",
    "CANNOT_UPLOAD_IMAGE_FOR_FIELD": "Cannot upload image for field",
    "CANT_LOAD_EVENTS_OF_CURRENT_PARTICIPANT": "Can't load events of current participant",
    "CARD_HOLDER_S_FIRST_NAME": "Cardholder's first name",
    "CARD_HOLDER_S_LAST_NAME": "Cardholder's last name",
    "CHANGE_PASSWORD": "Change password",
    "CHECK_YOUR_EMAIL": "Check your email",
    "CHECK_YOUR_EMAIL_INBOX_FOR_CREATE_ACCOUNT_LINK": "Check your email inbox for create account link",
    "CHECK_YOUR_EMAIL_INBOX_FOR_RESET_PASSWORD_LINK": "Check your email inbox for reset password link",
    "CHECK_YOUR_EMAIL_INBOX_FOR_THE_LOGIN_LINK": "Check you email inbox for the login link",
    "CLOSE": "Close",
    "CONFIRM": "Confirm",
    "CONFIRMED": "Confirmed",
    "CONFIRM_NEW_PASSWORD": "Confirm new password",
    "CONTACTS": "Contacts",
    "CREATE_ACCOUNT": "Create account",
    "CREDIT_CARD_NUMBER": "Credit card number",
    "CURRENT_ORDER": "Current order",
    "CURRENT_ORDER_TOTAL": "Current order total",
    "CURRENT_PASSWORD": "Current password",
    "CVV": "CVV",
    "DATE": "Date",
    "DENY": "Deny",
    "DESCRIPTION": "Description",
    "DETAILS": "Details",
    "DISCOUNT": "Discount",
    "DISCOUNT_CODE": "Discount code",
    "DOCUMENT_SELECTED": "Document selected",
    "DOCUMENT_UPLOADED": "Document uploaded",
    "DO_NOT_SEND_ANY_EMAIL": "Do not send any email",
    "DO_YOU_WANT_TO_CANCEL": "Do you want to cancel your registration?",
    "DO_YOU_WANT_TO_DECLINE_INVITATION": "Do you want to decline your invitation?",
    "EDIT": "Edit",
    "EDIT_SUB_PARTICIPANTS": "Edit invitee",
    "EMAIL": "Email",
    "EMAIL_CAMPAIGN_SUBSCRIPTIONS": "Email campaign subscriptions",
    "EMAIL_CONFIRMATION_CODE_SENT": "It looks like you have already tried to sign up, but abandoned or cancelled your previous registration. To confirm it is you, we have sent you a confirmation code to your email address. Please enter your code to continue your registration.",
    "END": "End",
    "ENTER_YOUR_EMAIL": "Enter your email",
    "ERROR_OCCURED_ON_FILE_UPLOAD": "Error occurred on file upload",
    "ERROR_OCCURED_ON_IMAGE_UPLOAD": "Error occurred on image upload",
    "EVENTS": "Events",
    "EXISTING_ORDER": "Existing order",
    "EXISTING_TRANSACTION_OVERVIEW": "Existing transaction overview",
    "EXPIRATION_DATE": "Expiration date",
    "FIELD_IS_EMPTY": "Field is empty",
    "FIRST_NAME": "First name",
    "FORGOT_MY_PASSWORD": "Forgot my password",
    "HIDE_TRANSACTIONS": "Hide transactions",
    "IF_THIS_EMAIL_HAS_AN_ACCOUNT_AN_EMAIL_WITH_A_LOGIN_LINK_HAS_BEEN_SENT": "If this email address has an account, an email with a login link has been sent. Check your email box for the login link",
    "IMPERSONATED_BANNER_TEXT": "You are now viewing an impersonated participant. You can close this tab when you are done updating this participant.",
    "INCORRECT_ACCESS_CODE": "Incorrect access code",
    "INGENICO_PAYMENT_DID_NOT_SUCCEED": "Ingenico payment did not succeed",
    "INVALID_DISCOUNT_CODE": "Invalid discount code",
    "INVALID_EMAIL": "Invalid email",
    "INVALID_TOKEN": "Invalid token",
    "INVITATION_HAS_BEEN_SENT": "An invitation has been sent",
    "INVITE": "Invite",
    "INVITE_CONTACT": "Invite contact",
    "INVITE_PEOPLE": "Invite people",
    "INVITE_PEOPLE_INFO": "You can invite upto <b>{{count}} people(s) (including yourself)</b>",
    "INVITE_SUB_PARTICIPANTS": "Invite friends",
    "ITEMS_PER_PAGE": "Items per page",
    "IT_IS_MANDATORY_TO_SELECT_AT_LEAST_ONE_ACTIVITY_OR_SESSION": "It is mandatory to select at least one activity or session",
    "LAST_NAME": "Last name",
    "LIKED": "Liked",
    "LIST": "List",
    "LOCATION": "Location",
    "LOGIN": "Log in",
    "LOGIN_FAILED": "Login failed",
    "LOGIN_LINK": "Login link",
    "LOGOUT": "Log out",
    "MAIN_PARTICIPANT": "Main participant",
    "MAIN_PARTICIPANT_TICKET_ASSIGNED": "Assign ticket to yourself",
    "MULTI_REGISTRATION_TABLE_EMPTY": "Currently no tickets assigned, please invite people",
    "MY_EVENTS": "My events",
    "MY_ORDERS": "My orders",
    "MY_ORGANIZATION": "My organization",
    "MY_PROFILE": "My profile",
    "NAME": "Name",
    "NEW_PASSWORD": "New password",
    "NEXT": "Next",
    "NO": "No",
    "NOT_AVAILABLE": "Not available",
    "NOT_LIKED": "Not liked",
    "NOT_REGISTERED": "Not registered",
    "NO_DOCUMENT": "No document",
    "OK": "Ok",
    "ONE_OR_MORE_MANDATORY_FIELDS_HAVE_NOT_BEEN_COMPLETED": "One or more mandatory fields have not been completed",
    "ORDER_AMOUNT": "Order amount is",
    "ORDER_SUMMARY": "Order summary",
    "OTHER": "Other",
    "PAID": "Paid",
    "PARTICIPANT_STAGE_UPDATED": "Participant stage is updated",
    "PASSWORD": "Password",
    "PASSWORDS_DOES_NOT_MATCH": "Passwords does not match",
    "PASSWORDS_DO_NOT_MATCH": "Passwords do not match",
    "PASSWORD_HAS_BEEN_CHANGED": "Password has been changed",
    "PAYMENT_DID_NOT_SUCCEED": "Payment did not succeed",
    "PAYMENT_SUCCEEDED": "Payment succeeded",
    "PAYMENT_TYPE": "Payment type",
    "PAYMENT_TYPE_IS_NOT_SELECTED": "Payment type is not selected",
    "PAYONE_PAYMENT_DID_NOT_SUCCEED": "PayOne payment did not succeed",
    "PAY_BY_INVOICE": "Pay by invoice",
    "PAY_ONLINE": "Pay online",
    "PENDING_APPROVAL": "Pending approval",
    "PENDING_ASSIGNMENT": "Pending assignment",
    "PENDING_CONFIRMATION": "Pending confirmation",
    "PLACES_LEFT": "Place(s) left",
    "PLEASE_ENTER_VALID_EMAIL_ADDRESS": "Please enter valid email address",
    "PREV": "Prev",
    "PREVIOUS_TRANSACTIONS": "Previous transaction(s)",
    "PRICE": "Price",
    "PROCEED": "Proceed",
    "PRODUCT": "Product",
    "PROFILE_UPDATED_SUCCESSFULLY": "Profile updated successfully",
    "QTY": "Qty",
    "QUANTITY": "Quantity",
    "REFUND": "Refund",
    "REFUND_AMOUNT_IS": "Refund amount is",
    "REGISTER": "Register",
    "REGISTERED": "Registered",
    "REMOVE": "Remove",
    "REMOVE_FROM_REGISTRATION": "Remove from registration",
    "REQUESTS": "Requests",
    "RESET_MY_ACCOUNT": "Reset my account",
    "RESET_PASSWORD": "Reset password",
    "REVERE_PAYMENT": "Revere payment",
    "ROOM": "Room",
    "SAVED": "Saved",
    "SCANNED": "Scanned",
    "SEARCH_CONTACT": "Search contact",
    "SEARCH_EVENT": "Search event",
    "SEARCH_PARTICIPANT": "Search participant",
    "SEATS_AVAILABLE": "Seats available",
    "SELECT_PAYMENT_TYPE": "Select payment type",
    "SELECT_QUANTITY_FOR_AT_LEAST_ONE_OF_THE_FOLLOWING_PRODUCTS": "Select quantity for at least one of the following products",
    "SEND_CODE_TO_MY_EMAIL": "Send code to my email",
    "SESSION_FEE": "Session fee",
    "SHOPPING_CART": "Shopping cart",
    "SHOW_EXISTING_ORDER": "Show existing order",
    "SHOW_IN_EVENT_TIME": "Show in event time",
    "SHOW_IN_MY_TIME": "Show in my time",
    "SHOW_LIKED": "Show liked",
    "SHOW_NOT_REGISTERED": "Show not registered",
    "SHOW_REGISTERED": "Show registered",
    "SHOW_TRANSACTIONS": "Show transactions",
    "SOLD_OUT": "Sold out",
    "SOME_OF_THE_SUPPLIED_DATA_IS_NOT_VALID": "One or more mandatory fields have not been filled in correctly.",
    "SPEAKER": "Speaker",
    "SPEAKER_INFO": "Speaker info",
    "START": "Start",
    "STATUS": "Status",
    "SUBMIT": "Submit",
    "SUBSCRIPTIONS": "Subscriptions",
    "SUBTOTAL": "Subtotal",
    "SUB_PARTICIPANT": "Sub-participant",
    "SUB_PARTICIPANTS": "Sub-participant(s)",
    "SUMMARY": "Summary",
    "SUPPLIED_CODE_IS_NO_LONGER_VALIED": "The supplied code is no longer valid, a new email with new link has been sent",
    "TABLE_PAGES_PAGE_COUNT": "Showing {{itemFrom}}-{{itemTo}} of {{totalItems}}",
    "TAX": "Tax",
    "TICKET": "Ticket",
    "TIMEZONE": "Timezone",
    "TOTAL": "Total",
    "TOTAL_AMOUNT": "Total amount",
    "TO_PAY": "To pay",
    "TRANSACTIONS": "Transactions",
    "TRANSACTION_CANCELLED": "Transaction cancelled",
    "TRANSACTION_OVERVIEW": "Transaction overview",
    "UNIT_PRICE": "Unit price",
    "UNKNOWN_PAYMENT_PROVIDER": "Unknown payment provider {{name}}",
    "UNREGISTER": "Unregister",
    "VERIFICATION_CODE": "Verification code",
    "VERIFY_MY_EMAIL": "Verify my email",
    "VIEW": "View",
    "VIEW_TRANSACTIONS": "View transactions",
    "WAITING_LIST": "Waiting list",
    "YES_DECLINE": "Yes, Decline",
    "YOUR_FORM_HAS_BEEN_SUBMITTED": "Your form has been submitted",
    "YOU_ARE_NOT_REGISTERED_CANNOT_CANCEL": "You are not registered. Cannot cancel."
}